module.exports = __webpack_public_path__ + "img/rightAni.21ed03ff.png";